import React, { useMemo } from "react";
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { useIntl, getLocale } from 'umi';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

export default function FirstColHeader(props) {
  const { sortKey, sortOrder, config, onSortChange } = props;
  const { type = 'GameInfo', title: propsTitle = 'Game', hasSort, hasRank, align, childWidth = 170, childAlign = 'right' } = config || {};

  const { formatMessage } = useIntl();
  const locale = getLocale();
  // 转换翻译
  const title: string = useMemo(() => {
    return formatMessage({ id: propsTitle });
  }, [propsTitle, locale]);

  const getElContent = (_type: string) => {
    switch (_type) {
      case 'date':
        return (
          <SortBy
            key={'date'}
            align={'left'}
            defaultKey={sortKey}
            defaultValue={sortOrder}
            list={[
              {
                key: `${'date'}_0`,
                text: title,
                title,
                ratioType: 0,
              },
            ]}
            title={title}
            isNoDropdown={!hasSort}
            onChange={onSortChange}
          />
        )
      default:
        return (
          <>
            <div className="dbi-firstRow-flex">
              {hasRank ? <div className="dbi-text-id">#</div> : null}
              <div>{title}</div>
              {propsTitle === 'dbi_main_genre' ? <TipContext className="tip-text-hd main-genre-tip" tipText={formatMessage({ id: 'dbi_genre_profile_main_genre_tips' })} />
                : null}
            </div>
          </>
        )
    }
  }

  return (
    <>
      {
        align === 'center'
          ? <CloumsCenter width={childWidth} align={childAlign}>
            {getElContent(type)}
          </CloumsCenter>
          : getElContent(type)
      }
    </>
  )
}